import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column'
import { FaRegTrashAlt } from 'react-icons/fa'
import { Btn, BtnIcon, CustomDataTable, CustomDropdown, Loading } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import {
  deletePosicaoEstoquePadraoProduto,
  getPosicoesEstoquePadraoProduto,
  savePosicaoEstoquePadraoProduto,
} from '../../../../services/api/https/registration/produto.http'
import { errorHandler } from '../../../../services/util/error.service'

const MSG_SEM_ESTOQUES = 'Não existe estoques cadastrados para o Operador Logístico selecionado'

export default function ModalProdutoPosicoesEstoquePadrao({
  produtoId,
  selectedTp,
  active,
  onResponse,
}) {
  const [estoques, setEstoques] = useState([])
  const [posicoes, setPosicoes] = useState([])
  const [selectedEstoque, setSelectedEstoque] = useState(null)
  const [selectedPosicao, setSelectedPosicao] = useState(null)
  const [associacoes, setAssociacoes] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (active && produtoId && selectedTp && selectedTp !== 0) {
      loadInitialData()
    }
  }, [active, produtoId, selectedTp])

  async function loadInitialData() {
    try {
      setIsLoading(true)
      const [fetchedEstoques, fetchedAssociacoes] = await Promise.all([
        EstoqueHttp.getEstoques(selectedTp),
        getPosicoesEstoquePadraoProduto(produtoId, selectedTp),
      ])

      setEstoques(fetchedEstoques)
      setAssociacoes(fetchedAssociacoes)
      setSelectedEstoque(null)
      setSelectedPosicao(null)
      setPosicoes([])

      if (!fetchedEstoques.length) {
        onResponse('error', MSG_SEM_ESTOQUES)
      }
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  async function onEstoqueChange(estoque) {
    setSelectedEstoque(estoque)
    setSelectedPosicao(null)
    setPosicoes([])

    if (!estoque) return

    try {
      setIsLoading(true)
      const fetchedPosicoes = await EstoqueHttp.getPosicoesEstoques(selectedTp, estoque.id)
      setPosicoes(fetchedPosicoes)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  async function onAdd() {
    if (!selectedEstoque) {
      onResponse('error', 'Selecione o estoque')
      return
    }

    if (!selectedPosicao) {
      onResponse('error', 'Selecione a posição de estoque')
      return
    }

    try {
      setIsLoading(true)
      const fetchedAssociacoes = await savePosicaoEstoquePadraoProduto(
        produtoId,
        selectedTp,
        selectedPosicao.id,
      )
      setAssociacoes(fetchedAssociacoes)
      setSelectedPosicao(null)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  async function onDelete(row) {
    try {
      setIsLoading(true)
      const fetchedAssociacoes = await deletePosicaoEstoquePadraoProduto(
        produtoId,
        selectedTp,
        row.id,
      )
      setAssociacoes(fetchedAssociacoes)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="p-grid p-align-end" style={{ width: 760 , height: 400}}>
      <div className="p-col-12">
        <span style={{  fontSize: '0.85rem' }}>
          Adicione as posições de estoque, onde o produto deve ser idealmente internado. Elas estarão
          disponíveis no Modelo de Etiqueta - <strong>Modelo Padrão - Com Pos. Estoque</strong> , na emissão da
          TAG no Aplicativo Expedição
        </span>
      </div>
      <div className="p-md-5 p-col-12">
        <CustomDropdown
          label="Estoque"
          optionLabel="name"
          filter
          options={estoques}
          value={selectedEstoque}
          onChange={onEstoqueChange}
          placeholder="Selecione"
        />
      </div>
      <div className="p-md-5 p-col-12">
        <CustomDropdown
          label="Posição de Estoque"
          optionLabel="endereco"
          filter
          options={posicoes}
          value={selectedPosicao}
          onChange={setSelectedPosicao}
          placeholder="Selecione"
          disabled={!selectedEstoque}
        />
      </div>
      <div className="p-md-2 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Btn style={{ marginBottom: 0 }} disabled={isLoading} onClick={onAdd}>
          Adicionar
        </Btn>
      </div>
      <div className="p-col-12">
        {isLoading ? (
          <div className="text-center">
            <Loading size="md" />
          </div>
        ) : (
          <CustomDataTable
            value={associacoes}
            paginator
            rows={5}
            emptyMessage="Não existem posições padrão cadastradas para este produto"
          >
            <Column field="estoque_name" header="Estoque" />
            <Column field="endereco" header="Posição" />
            <Column
              header=""
              style={tableCellCentered(80)}
              body={row => (
                <BtnIcon onClick={() => onDelete(row)}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
            />
          </CustomDataTable>
        )}
      </div>
    </div>
  )
}
